import type { SemanticAd } from "src/types/SemanticAd";
import { Ad as AdComponent } from "./Ad/Ad";
import { AdImage } from "./Ad/AdImage";
import { FavoriteHeart } from "./FavoriteHeart";
import { RecommerceAd } from "./types";

const IMAGE_SIZES =
	"(min-width: 1300px) 306px, (min-width: 1010px) 316px, (min-width: 768px) 33vw, (min-width: 480px) 50vw, 100vw";

export type AdProps = {
	ad: SemanticAd;
	isMobile: boolean;
	onClick: () => void;
	onFirstInscreen?: () => void;
	currency: string;
};

export function Ad(props: AdProps) {
	const { ad, onClick, onFirstInscreen, isMobile, currency } = props;

	const recommerceAd = {
		id: String(ad.id),
		price: {
			amount: ad.price?.amount,
			currency_code: ad.price?.currencyCode || currency,
		},
		heading: ad.heading,
		trade_type: ad.tradeType,
		image: {
			url: ad.image?.url,
			width: ad.image?.width,
			height: ad.image?.height,
		},
		location: ad.location,
		flags: ad.flags,
		extras: ad.extras,
		labels: ad.labels,
	};

	return (
		<AdComponent
			ad={{ ...(recommerceAd as RecommerceAd) }}
			favorite={() => <FavoriteHeart itemId={ad.id} variant={"heart-on-image"} isMobile={isMobile} />}
			id={ad.id}
			imageSizes={IMAGE_SIZES}
			onClick={onClick}
			onFirstInscreen={onFirstInscreen}
			url={"/recommerce/forsale/item/" + ad.id}
			image={() => (
				<AdImage
					aspectClass="aspect-3/4"
					height={ad.image?.height}
					width={ad.image?.width}
					url={ad.image?.url}
					crop={true}
					sizes={IMAGE_SIZES}
				/>
			)}
		/>
	);
}
